export const makeTdConfig = (year, month, day) => ({
  chartTop: {
    title: '過去の天気',
    description: '【過去の天気｜ウェザーニュース】2021年から現在までの過去天気図を一覧で掲載。昨日や1週間前、去年など天気図の移り変わりでその日の気圧配置と天気の様子がわかります。最新の気象・防災情報は予報精度No.1ウェザーニュースで。',
    keyword: '過去の天気,天気図'
  },
  chartMonth: {
    title: `過去の天気図【${year}${month}】`,
    description: `【${year}${month}の天気図】日毎の天気図の移り変わりを一覧で確認できます。昨日や1週間前、去年など天気図の移り変わりでその日の気圧配置と天気の様子がわかります。最新の気象・防災情報は予報精度No.1ウェザーニュースで。`,
    keyword: `天気図,${year}${month}`
  },
  chartDay: {
    title: `過去の天気図【${year}${month}${day}】`,
    description: `【${year}${month}${day}の天気図】3時間ごとの天気図の変化で、${month}${day}の気圧配置と天気の様子がわかります。最新の気象・防災情報は予報精度No.1ウェザーニュースで。`,
    keyword: `天気図,${year}${month}${day}`
  },
  satelliteTop: {
    title: '過去の気象衛星',
    description: '【過去の気象衛星｜ウェザーニュース】気象衛星ひまわりにより観測した、2021年から現在までの日本付近の衛星画像(赤外)を一覧で掲載。昨日や1週間前、去年などの過去の雲の動きがわかります。過去の天気図と切り替え可能。最新の気象・台風・防災情報は予報精度No.1ウェザーニュースで。',
    keyword: '過去の天気,気象衛星'
  },
  satelliteMonth: {
    title: `過去の気象衛星【${year}${month}】`,
    description: `【${year}${month}の気象衛星】気象衛星ひまわりにより観測した、日本付近の日毎の衛星画像(赤外)を確認できます。昨日や1週間前、去年などの過去の雲の動きがわかります。最新の気象・台風・防災情報は予報精度No.1ウェザーニュースで。`,
    keyword: `気象衛星,${year}${month}`
  },
  satelliteDay: {
    title: `過去の気象衛星【${year}${month}${day}】`,
    description: `【${year}${month}${day}の気象衛星】気象衛星ひまわりにより観測した1時間ごとの日本付近の衛星画像(赤外)を掲載。${month}${day}の雲画像の様子で、雲の動きと天気の流れがわかります。最新の気象・台風・防災情報は予報精度No.1ウェザーニュースで。`,
    keyword: `気象衛星,${year}${month}${day}`
  }
})
